module.exports = __webpack_public_path__ + "img/twitter.b0718e12.svg";